import { native } from '@forest/native-services'
import type { InvalidSaleReason } from './effective-price'

// One diagnostics shape for every collection's ignored sale (ADR 0027).
export function invalidSaleReporter(
  productId: number,
  gid?: number,
): (reason: InvalidSaleReason) => void {
  return (reason) =>
    logNonFatal('shop_invalid_sale_ignored', {
      reason,
      product_id: String(productId),
      ...(gid === undefined ? {} : { gid: String(gid) }),
    })
}

// Fire-and-forget non-fatal report: a failed or unavailable bridge must
// never affect the flow that emitted the diagnostic.
export function logNonFatal(
  name: string,
  params: Record<string, string>,
): void {
  try {
    void native.general
      .logNonFatalError({ name, code: 1, params })
      .catch(() => {})
  } catch {
    // Bridge errors are swallowed with the report.
  }
}
